// opervex-frontend/src/pages/Reports/StockSerial.js

import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DynamicReport from "../../components/DynamicReport";
import useOpervex from "../../hooks/useOpervex";

const StockSerial = () => {
  const [schema, setSchema] = useState(null);
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const loadSchema = async () => {
      const result = await OpervexAPI.Report.StockSerial.schema();
      setSchema(result);
    };

    loadSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schema)
    return (
      <Container fluid className="text-center mt-5">
        <span>Carregando relatório...</span>
      </Container>
    );

  return (
    <>
      <h1 className="fw-light text-center">Relatório de Estoque Serial</h1>

      <DynamicReport reportName={"reportSockSerial"} urlData={"/Report/StockSerial"} schema={schema} />
    </>
  );
};

export default StockSerial;
